// extracted by mini-css-extract-plugin
export default {"container":"LeftImageContainer_container__8mtBG"};